import { type Currency, CURRENCY_OPTIONS } from 'api';
import { Box, type SelectChangeEvent } from 'ui';

import { SelectField, type SelectFieldProps } from '../SelectField/SelectField';
import { TextField, type TextFieldProps } from '../TextField/TextField';

type Props = {
  label: string;
  priceName: string;
  currencyLabel?: string;
  currencyName: string;
  required?: boolean;
  defaultCurrency?: Currency;
  'data-testid'?: string;
  onCurrencyChange?: (event: SelectChangeEvent<string>) => void;
  infoTooltip?: string;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
  disabled?: boolean;
  helperText?: string;
  slotProps?: {
    currency?: Partial<SelectFieldProps>;
    price?: Partial<TextFieldProps>;
  };
};

export const PriceAndCurrencyField = ({
  priceName,
  currencyLabel,
  currencyName,
  label,
  onCurrencyChange,
  required = false,
  infoTooltip,
  fullWidth = true,
  size,
  disabled,
  helperText,
  'data-testid': dataTestId,
  slotProps,
}: Props) => {
  return (
    <Box display="flex" flexDirection="row" data-testid={dataTestId} width={fullWidth ? '100%' : undefined}>
      <SelectField
        label=""
        inputProps={{
          'aria-label': currencyLabel ?? '',
        }}
        name={currencyName}
        onChange={(event) => onCurrencyChange?.(event)}
        sx={{
          flexShrink: 0,
          mr: 1,
          width: '60px',
        }}
        options={CURRENCY_OPTIONS}
        fullWidth={false}
        size={size}
        disabled={disabled}
        {...slotProps?.currency}
      />
      <TextField
        label={label}
        name={priceName}
        type="number"
        required={required}
        infoTooltip={infoTooltip}
        fullWidth={fullWidth}
        size={size}
        disabled={disabled}
        helperText={helperText}
        {...slotProps?.price}
      />
    </Box>
  );
};
